export var EditedDefinitionScope = /*#__PURE__*/function (EditedDefinitionScope) {
  EditedDefinitionScope["SPACE"] = "SPACE";
  EditedDefinitionScope["PAGE"] = "PAGE";
  EditedDefinitionScope["BLOGPOST"] = "BLOGPOST";
  EditedDefinitionScope["ORGANIZATION"] = "ORGANIZATION";
  EditedDefinitionScope["PROJECT"] = "PROJECT";
  return EditedDefinitionScope;
}({});